// extracted by mini-css-extract-plugin
module.exports = {"household_applicant_review_application_complete_banner":"style_household_applicant_review_application_complete_banner__HajzQ"};